import { render, staticRenderFns } from "./CspaceLikeBtn.vue?vue&type=template&id=5b762712"
import script from "./CspaceLikeBtn.vue?vue&type=script&lang=js"
export * from "./CspaceLikeBtn.vue?vue&type=script&lang=js"
import style0 from "./CspaceLikeBtn.vue?vue&type=style&index=0&id=5b762712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports